<template>
  <svg aria-hidden="true" :width="width" :height="height"  @click="handleClick">
    <use :xlink:href="href" />
  </svg>
</template>

<script>
/* 锁 */
import lockIcon from 'assets/icons/lock.svg';
/* 目录 */
import catalogIcon from 'assets/icons/catalog.svg';
/* 学科素养 */
import attainmentIcon from 'assets/icons/attainment.svg';
/* 课文导读 */
import textReadGuideIcon from 'assets/icons/text.svg';
/* 相关阅读 */
import relatedArticleIcon from 'assets/icons/relatedarticle.svg';
/* 诵读 */
import readIcon from 'assets/icons/read.svg';
/* 优秀作品 */
import excellentWorkIcon from 'assets/icons/excellentwork.svg';
/* 写作指导 */
import writingGuideIcon from 'assets/icons/writingguide.svg';
/* 画线标签管理 */
import lineLabelIcon from 'assets/icons/linelabel.svg';
/* 我的参与 */
import myParticipationIcon from 'assets/icons/myparticipation.svg';
/* 活动 */
import myActionicon from 'assets/icons/myaction.svg';
/* 做任务 */
import doTaskIcon from 'assets/icons/dotask.svg';
/* 做习题 */
import doPracticeIcon from 'assets/icons/dopractice.svg';
/* 返回 */
import leftDobuleArrowIcon from 'assets/icons/leftdobulearrow.svg';
/* 画线 */
import userDrawLineIcon from 'assets/icons/userdrawline.svg';
/* 评论 */
import commentIcon from 'assets/icons/comment.svg';
/* 提问 */
import askQuestionsIcon from 'assets/icons/askquestions.svg';
/* 复制 */
import copyIcon from 'assets/icons/copy.svg';
/* 录音 */
import recIcon from 'assets/icons/rec.svg';
/* 录音暂停 */
import recPauseIcon from 'assets/icons/recpause.svg';
/* 录音停止 */
import recStopIcon from 'assets/icons/recstop.svg';
/* 录音回放 */
import recPlayIcon from 'assets/icons/recplay.svg';
/* 录音历史 */
import recHistoryIcon from 'assets/icons/recordhistory.svg';
/* 显示----文言文 */
import showIcon from 'assets/icons/show.svg';
/* 微课 */
import microLessonIcon from 'assets/icons/microlesson.svg';
/* 单元导读 */
import unitGuideIcon from 'assets/icons/unitguide.svg';
/* 删除 */
import deleteIcon from 'assets/icons/delete.svg';
/* 系统消息 */
import sysMsgIcon from 'assets/icons/sysmsg.svg';
/* 专题及文章 */
import articleMsgIcon from 'assets/icons/articlemsg.svg';
/* 去完成任务pink */
import achivePink from 'assets/icons/42.svg';
/* 今日完成签到 */
import achiveIcon from 'assets/icons/40.svg';
/* 今日未完成签到 */
import unachiveIcon from 'assets/icons/41.svg';
/* 图书名字icon */
import bookName from 'assets/icons/bookName.svg';
/* circle */
import circlePlay from 'assets/icons/circleplay.svg';
import commentblack from 'assets/icons/commentblack.svg';
import askblack from 'assets/icons/askblack.svg';
import view from 'assets/icons/view.svg';
import textsetting from 'assets/icons/textsetting.svg';
import backgroundmusicon from 'assets/icons/backgroundmusicon.svg';
import backgroundmusicoff from 'assets/icons/backgroundmusicoff.svg';
import translate from 'assets/icons/translate.svg';
import readingstatus from 'assets/icons/readingstatus.svg';
// and so on ...
// 教师端图标
import svg1 from 'assets/svg/01-01.svg';
import svg11 from 'assets/svg/01-02.svg';
import svg2 from 'assets/svg/02-01.svg';
import svg22 from 'assets/svg/02-02.svg';
import svg3 from 'assets/svg/03-01.svg';
import svg33 from 'assets/svg/03-02.svg';
import svg4 from 'assets/svg/04-01.svg';
import svg44 from 'assets/svg/04-02.svg';
import svg5 from 'assets/svg/05-01.svg';
import svg55 from 'assets/svg/05-02.svg';
import svg6 from 'assets/svg/06-01.svg';
import svg66 from 'assets/svg/06-02.svg';
import svg7 from 'assets/svg/07-01.svg';
import svg77 from 'assets/svg/07-02.svg';
import svg8 from 'assets/svg/08-01.svg';
import svg88 from 'assets/svg/08-02.svg';
import svg9 from 'assets/svg/09-01.svg';
import svg99 from 'assets/svg/09-02.svg';
import svg10 from 'assets/svg/10-01.svg';
import svg1010 from 'assets/svg/10-02.svg';
import svg1_1 from 'assets/svg/11-01.svg';
import svg1111 from 'assets/svg/11-02.svg';
import svg1_2 from 'assets/svg/12-01.svg';
import svg1212 from 'assets/svg/12-02.svg';
import relart1 from 'assets/svg/rel-art-01.svg';
import relart2 from 'assets/svg/rel-art-02.svg';
import stroke from 'assets/icons/stroke.svg';
import chexiao from 'assets/icons/chexiao.svg';
import redo from 'assets/icons/redo.svg';
import pen from 'assets/icons/pen.svg';
import curve from 'assets/icons/curve.svg';
import straight from 'assets/icons/line.svg';
import circle from 'assets/icons/circle.svg';
import rectangle from 'assets/icons/rectangle.svg';
import eraser from 'assets/icons/eraser.svg';
import wenzi from 'assets/icons/wenzi.svg';
import move from 'assets/icons/move.svg';
import clearAll from 'assets/icons/clearAll.svg';
import jiaoan from 'assets/svg/jiaoan-pressed.svg';
import jiaoanNormal from 'assets/svg/jiaoan-unpressed.svg';

export default {
  name: 'HanIcon',
  props: {
    type: String,
    width: {
      type: String,
      default: '30px',
    },
    height: {
      type: String,
      default: '30px',
    },
  },
  data() {
    return {
      icons: {
        lockIcon,
        catalogIcon,
        attainmentIcon,
        textReadGuideIcon,
        relatedArticleIcon,
        readIcon,
        excellentWorkIcon,
        writingGuideIcon,
        lineLabelIcon,
        myParticipationIcon,
        myActionicon,
        doTaskIcon,
        doPracticeIcon,
        leftDobuleArrowIcon,
        userDrawLineIcon,
        commentIcon,
        askQuestionsIcon,
        copyIcon,
        recIcon,
        recPauseIcon,
        recStopIcon,
        recPlayIcon,
        recHistoryIcon,
        showIcon,
        microLessonIcon,
        unitGuideIcon,
        deleteIcon,
        sysMsgIcon,
        articleMsgIcon,
        achivePink,
        achiveIcon,
        unachiveIcon,
        bookName,
        circlePlay,
        commentblack,
        askblack,
        view,
        textsetting,
        backgroundmusicon,
        backgroundmusicoff,
        translate,
        readingstatus,
        svg1,
        svg11,
        svg2,
        svg22,
        svg3,
        svg33,
        svg4,
        svg44,
        svg5,
        svg55,
        svg6,
        svg66,
        svg7,
        svg77,
        svg8,
        svg88,
        svg9,
        svg99,
        jiaoan,
        jiaoanNormal,
        svg10,
        svg1010,
        svg1_1,
        svg1111,
        svg1_2,
        svg1212,
        relart1,
        relart2,
        stroke,
        chexiao,
        redo,
        pen,
        curve,
        straight,
        circle,
        rectangle,
        eraser,
        wenzi,
        move,
        clearAll,
      },
    };
  },
  computed: {
    icon() {
      return this.icons[this.type];
    },
    href() {
      return `#${this.icon.id}`;
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
